// Walk a dynamic-zone tree of any depth looking for nodes with a given
// __typename and return their items concatenated. Needed because page content
// nests QuestionsBlock inside LightBlock / DarkBlock / SharedComponent — a
// flat .filter() at the top level would never find it.
export const collectFaqItems = (root, typename, itemsField) => {
  const result = [];
  const visit = (node) => {
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    if (node.__typename === typename) {
      result.push(...(node[itemsField] || []));
      return;
    }
    for (const value of Object.values(node)) {
      if (value && typeof value === 'object') visit(value);
    }
  };
  visit(root);
  return result;
};
